import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=d272f224&scoped=true"
import script from "./confirm.vue?vue&type=script&lang=ts"
export * from "./confirm.vue?vue&type=script&lang=ts"
import style0 from "./confirm.vue?vue&type=style&index=0&id=d272f224&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d272f224",
  null
  
)

export default component.exports